<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title"><strong>{{'CONTRACT_NUMBER_CREATE' | translate}}</strong></p>
    <button type="button" class="close" (click)="closeDialog()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <mat-dialog-content style="overflow:visible">
      <form (ngSubmit)="save()" #f="ngForm" id="form"
            [formGroup]="formGroup" novalidate>

        <div class="row form-group"
             [ngClass]="{ 'has-danger': hasLocalFieldError('contractNumber')}">
          <label
            class="col-form-label form-control-label col-md-4 detail-title"
            [class.required-field-label]="true">{{'CUSTOMER_RECORD_CONTRACT_NUMBER' | translate}}</label>
          <div class="col-md-8">
            <div class="mw-100">
              <input type="text"
                     [(ngModel)]="model.contractNumber"
                     [ngClass]="{ 'form-control-danger': hasLocalFieldError('contractNumber') }"
                     class="form-control"
                     name="contractNumber"
                     id="contractNumber"
                     formControlName="contractNumber"
                     placeholder="{{'CUSTOMER_RECORD_CONTRACT_NUMBER'|translate}}">
              <div class="form-control-feedback" *ngIf="hasLocalFieldError('contractNumber')">
                {{'COMMON_VALIDATION_MESSAGE_REQUIRED' | translate}}
              </div>
            </div>
          </div>
        </div>
      </form>
    </mat-dialog-content>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="closeDialog()">
      {{'COMMON_BUTTON_CANCEL' | translate}}
    </button>
    <button type="submit" class="btn btn-primary" form="form">
      {{'COMMON_BUTTON_SAVE' | translate}}
    </button>
  </div>
</div>
